import React from "react";
import CSATRatingTab from "./CSATRatingTab";
import ManageCSATRatings from "./ManageCSATRatings";
import { useState, useEffect } from "react";
import { useBreadcrumbs } from "../../../v2/context/breadcrumb/breadcrumb-context.tsx";

export const CSATTabs = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { setBreadcrumbs } = useBreadcrumbs();
  const tabs = [
    { label: "Manage CSAT Ratings", component: ManageCSATRatings },
    { label: "Add CSAT Ratings", component: CSATRatingTab },
  ];
  useEffect(() => {
    setBreadcrumbs([
      { label: "CSAT Rating", path: "/dashboard/csatRating" },
      { label: tabs[activeTabIndex].label },
    ]);
  }, [activeTabIndex]);
  return (
    <>
      <div className="wrapper-body">

        <div className="card csat-rating-card rounded-lg">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <ul className="nav nav-tabs" role="tablist">
              {tabs.map((item, index) => (
                <li className="nav-item" role="presentation" key={index}>
                  <button
                    className={`nav-link ${activeTabIndex === index ? "active" : ""
                      }`}
                    type="button"
                    role="tab"
                    aria-selected={activeTabIndex === index}
                    onClick={() => setActiveTabIndex(index)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="tab-content mt-3 px-3">
            {tabs.map((item, index) => {
              const Component = item.component;
              return (
                activeTabIndex === index && (
                  <div
                    key={index}
                    className={`tab-pane fade show active`}
                    role="tabpanel"
                  >
                    <Component title={item.label} description={""} />
                  </div>
                )
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
